module.exports = __webpack_public_path__ + "img/pg5-article-text2.6e64b987.png";